import VueDOMPurifyHTML from "vue-dompurify-html";
export function setupDompurifyDirective(app: any) {
  app.use(VueDOMPurifyHTML as any);
}
